var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationArbeitsrecht(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1184.7 886.5",
    style: {
      enableBackground: "new 0 0 1184.7 886.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4F4F4;}\n\t.st1{fill:#B0B4B9;}\n\t.st2{fill:#D8DBDD;}\n\t.st3{opacity:0.15;enable-background:new    ;}\n\t.st4{fill:#D1D3D4;}\n\t.st5{fill:#858990;}\n\t.st6{fill:#B2B6BB;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#137F7B;}\n\t.st9{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st10{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st11{opacity:0.85;fill:#FFFFFF;enable-background:new    ;}\n\t.st12{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st13{fill:#61656D;}\n\t.st14{fill:#868A91;}\n\t.st15{fill:#B1B5BA;}\n\t.st16{opacity:0.2;}\n\t.st17{opacity:0.2;fill:#137F7B;enable-background:new    ;}\n\t.st18{opacity:0.37;fill:#137F7B;enable-background:new    ;}\n\t.st19{fill:#FFFFFF;stroke:#61656D;stroke-miterlimit:10;}\n\t.st20{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st21{opacity:0.5;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}\n\t.st22{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st23{fill:#DDDDDD;}\n\t.st24{fill:#DADDDF;}\n\t.st25{opacity:0.2;enable-background:new    ;}\n\t.st26{fill:#C46F69;}\n\t.st27{opacity:0.15;}\n\t.st28{fill:#25282F;}\n\t\n\t\t.st29{opacity:0.3;fill:none;stroke:#000000;stroke-width:1.0357;stroke-linecap:round;stroke-linejoin:round;enable-background:new    ;}\n\t.st30{opacity:0.3;enable-background:new    ;}\n\t.st31{fill:#21252B;}\n\t.st32{fill:none;stroke:#21252B;stroke-width:1.3395;stroke-miterlimit:10;}\n\t.st33{fill:#F2F8FC;}\n\t.st34{fill:#3F4249;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000171686377577558629880000001974559815902768261_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 665.5,
    cy: 810.3,
    rx: 481.5,
    ry: 34
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1057.6,491.8h77.7c0.5,0,1-0.1,1.5-0.3s0.9-0.5,1.3-0.9s0.7-0.8,0.8-1.3c0.2-0.5,0.3-1,0.3-1.5 s-0.1-1-0.3-1.5s-0.5-0.9-0.8-1.3c-0.4-0.4-0.8-0.7-1.3-0.9s-1-0.3-1.5-0.3h-77.7V491.8L1057.6,491.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1125.3,488h-78.4v241.5h78.4V488z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1049.3,488H809.5v241.5h239.8V488z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1037.1,711H820.6V521.5l216.5,0.2V711L1037.1,711z M822.4,709.3h213V523.5h-213V709.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M800.5,491.8h257.2c0.5,0,1-0.1,1.5-0.3s0.9-0.5,1.3-0.9s0.7-0.8,0.8-1.3c0.2-0.5,0.3-1,0.3-1.5 s-0.1-1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.3c-0.4-0.4-0.8-0.7-1.3-0.9s-1-0.3-1.5-0.3H800.5c-0.5,0-1,0.1-1.5,0.3s-0.9,0.5-1.3,0.9 c-0.4,0.4-0.7,0.8-0.9,1.3s-0.3,1-0.3,1.5c0,1,0.4,2,1.2,2.8C798.5,491.3,799.5,491.8,800.5,491.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1037.1,615.1H820.6v1.7h216.5V615.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M919.6,552c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6S916.3,552,919.6,552z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M921.8,546c0-1.2-0.4-2.5-1.1-3.5s-1.7-1.8-2.9-2.2c0.6-0.2,1.3-0.4,2-0.3c1.6,0,3.1,0.6,4.2,1.8 c1.1,1.1,1.8,2.7,1.8,4.2c0,1.6-0.6,3.1-1.8,4.2c-1.1,1.1-2.7,1.8-4.2,1.8c-0.7,0-1.4-0.1-2-0.3c1.2-0.4,2.2-1.2,2.9-2.2 C921.4,548.4,921.8,547.2,921.8,546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M919.6,645.2c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6S916.3,645.2,919.6,645.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M921.8,639.2c0-1.2-0.4-2.5-1.1-3.5s-1.7-1.8-2.9-2.2c0.6-0.2,1.3-0.4,2-0.3c1.6,0,3.1,0.6,4.2,1.8 c1.1,1.1,1.8,2.7,1.8,4.2c0,1.6-0.6,3.1-1.8,4.2c-1.1,1.1-2.7,1.8-4.2,1.8c-0.7,0-1.4-0.1-2-0.3c1.2-0.4,2.2-1.2,2.9-2.2 C921.4,641.7,921.8,640.5,921.8,639.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1061.7,499.9l-12.4-8.1H809.5v3.7L1061.7,499.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1109.8,729.4l6,66.8c0.1,0.6,0.1,1.2,0,1.7c-0.2,0.6-0.4,1.1-0.8,1.5s-0.8,0.8-1.3,1.1 c-0.5,0.3-1.1,0.4-1.7,0.4c-0.8,0-1.6-0.3-2.3-0.8s-1.2-1.2-1.4-1.9l-17.5-68.9L1109.8,729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1107.7,768.3l-7.3-1.7l-9.4-37.1h19l6,66.8c0.2,0.9,0,1.8-0.4,2.6c-0.4,0.8-1.1,1.4-1.9,1.8L1107.7,768.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1041.7,729.4l6,66.8c0.1,0.6,0.1,1.2-0.1,1.7c-0.1,0.6-0.4,1.1-0.8,1.5s-0.8,0.8-1.3,1.1 c-0.5,0.2-1.1,0.4-1.7,0.4c-0.8,0-1.6-0.3-2.3-0.8c-0.7-0.5-1.2-1.1-1.4-1.9l-17.5-68.9L1041.7,729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1035.3,736.8l-10.9-2.1l-1.8-5.3h19l6,66.8c0.2,0.9,0,1.8-0.4,2.6c-0.4,0.8-1.1,1.4-1.9,1.8L1035.3,736.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M891.3,729.4l-6,66.8c-0.1,0.6-0.1,1.2,0.1,1.7c0.1,0.6,0.4,1.1,0.8,1.5s0.8,0.8,1.3,1.1s1.1,0.4,1.7,0.4 c0.8,0,1.6-0.3,2.3-0.8c0.7-0.5,1.2-1.2,1.4-1.9l17.5-68.9L891.3,729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M894.7,765l-6.5-1.6l3.1-33.9h19l-17.5,68.9c-0.3,0.8-0.8,1.4-1.4,1.9c-0.7,0.5-1.5,0.8-2.3,0.8h-0.2 L894.7,765z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M821.3,729.4l-6,66.8c-0.1,0.6-0.1,1.2,0,1.7c0.1,0.6,0.4,1.1,0.8,1.5s0.8,0.8,1.3,1.1 c0.5,0.2,1.1,0.4,1.7,0.4c0.8,0,1.6-0.3,2.3-0.8s1.2-1.1,1.4-1.9l17.5-68.9L821.3,729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M828.7,735.2l-8.3-1.5l0.9-4.3h19l-17.5,68.9c-0.3,0.8-0.8,1.4-1.4,1.9c-0.7,0.5-1.4,0.7-2.3,0.8h-0.2 L828.7,735.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M975.8,351.2c-6.1-3.8-13.1-6.2-20.3-7c-3.3-0.3-7-0.2-9.6,1.8c-0.6,0.4-1.1,1-1,1.7c0.2,0.5,0.5,0.9,0.9,1.2 c4.3,3.1,9.4,4.9,14.7,5.3C965.8,354.7,971.1,353.6,975.8,351.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M975.3,350.7c-4.7-3.5-9.1-7.3-13.1-11.5c-4-4.3-6.9-9.5-8.2-15.2c-0.3-0.8-0.3-1.7-0.2-2.6 c0.1-0.9,0.4-1.7,0.9-2.5C965.1,327,973.3,337.5,975.3,350.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M975.7,351.2c-1-5.7-0.9-11.5,0.2-17.2c1.2-5.7,4.4-10.8,9.2-14.2c1.9,4.2,1,9.1-0.2,13.5 c-2,6.8-5,13.3-9.1,19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M985.9,369.6c-6.2,1-11.8,3.9-16.3,8.2c-4.7,4.2-8,9.8-9.4,16c6.1-0.4,11.2-4.7,15-9.5s6.4-10.1,10.5-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M988.2,372.5c-2.4-6.2-3.3-13-2.5-19.6s3.3-13,7.1-18.4c1.9,6.3,2.4,12.9,1.6,19.5 C993.6,360.5,991.5,366.8,988.2,372.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1001.7,388.6c-5.7-0.3-11.3,1-16.3,3.8c-4.9,2.8-8.9,7.1-11.5,12.2c-0.2,0.3-0.3,0.7-0.4,1.1 c0,0.4,0,0.8,0.2,1.1c0.2,0.2,0.5,0.4,0.9,0.5c0.3,0.1,0.7,0.1,1,0c5.5-0.4,10.3-3.7,14.3-7.4S997.4,391.8,1001.7,388.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1001.3,387.7c-2.9-9.4-3.1-19.4-0.5-28.9c1-3.7,2.7-7.6,6.2-9.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0,0.5,0 c0.3,0.1,0.5,0.4,0.6,0.7c1.2,2.6,1.7,5.4,1.4,8.3c-0.2,2.8-0.6,5.6-1.3,8.4c-1.1,5.1-1.7,10.6-4.5,15c-0.7,1.1-1.3,2.2-1.9,3.3 c-0.5,1.1-0.5,1.5-1,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1037.1,393c-1.2-5.3-1.2-10.7-0.1-16s3.4-10.3,6.6-14.6c0.2-0.3,0.5-0.6,0.8-0.8s0.7-0.3,1.1-0.4 c1.2,0.1,1.5,1.7,1.4,2.8C1046.4,374.5,1043,384.5,1037.1,393"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1040.3,395.2c6.3,1.5,12.8,1.6,19.1,0.3c6.3-1.3,12.3-3.9,17.5-7.8c-6.1-3.1-13.1-3.9-19.8-2.4 C1050.5,386.5,1044.5,390,1040.3,395.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1043,388.5c3.6-5.6,8.5-10.2,14.3-13.6s12.2-5.3,18.9-5.6c-0.9,2.6-2.3,5.1-4.2,7.1c-1.9,2.1-4.1,3.7-6.7,4.9 c-5.1,2.3-10.4,3.8-15.9,4.7C1047.3,386.4,1044.4,386.8,1043,388.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1037.8,355.9c2.1-6.3,3.5-12.8,4.2-19.4c0.7-6.7-0.6-13.4-3.9-19.3c-3.3,6-5,12.7-5.1,19.6s1.5,13.6,4.6,19.7 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1059.4,345c7.5-13.6,22.8-24.5,38.3-26.1C1091.7,333.8,1075.4,345.3,1059.4,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1054.7,347.7c11.2,1.7,20.7,8.8,31.2,13.1c2.2,1.1,4.6,1.5,7.1,1.4c1.1-0.1,2.2-0.4,3.1-1.1 c0.9-0.7,1.6-1.6,1.9-2.6c0.4-1,0.4-2.2,0.2-3.2s-0.9-2-1.7-2.8c-1.5-1.4-3.2-2.4-5.1-3.1c-11.4-4.8-23.6-4.9-35.6-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1048.2,355.5c2.5,0.7,3.4,2,5.4,3.7c6.8,5.8,14.9,10,23.6,12.2c0.9,0.2,2.1,0.3,2.5-0.5s0-1.6-0.6-2.2 c-3.8-4.5-8.7-7.8-14.3-9.7c-5.5-2-10.2-4.5-16.7-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1040.9,308.1c4.6,4.2,10,7.5,15.9,9.5s12.2,2.8,18.4,2.2c0.6,0,1.1-0.2,1.6-0.6c0.9-0.9-0.2-2.4-1.2-3.2 C1065.5,308.2,1053.3,304.9,1040.9,308.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1049.5,304.9c6.1-4.5,13.1-7.5,20.6-8.7s15.1-0.7,22.3,1.6c-5.6,5.2-12.8,8.4-20.4,9 C1064.4,307.5,1056.8,306.9,1049.5,304.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1046.1,283.1c-1-10.1-0.3-18-1-28.1c0-0.8-0.2-1.8-1-2.1c-0.8-0.3-1.9,0.9-2.3,2c-1.5,4.7-1.9,9.7-1.1,14.5 C1041.4,274.4,1043.3,279,1046.1,283.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1045.4,284.3c6.6-4.3,12.2-9.8,16.7-16.2c3.3-4.5,6.1-9.9,5.3-15.4c-2.3,0.1-4.6,0.6-6.7,1.7 c-2.1,1-3.9,2.5-5.3,4.3c-2.9,3.6-5,7.9-6.1,12.3c-1.3,4.4-2.3,9-3.7,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1061.8,279.8c15-5.6,28.9-13.8,41-24.3c-4.9-1.9-10.5-0.8-15.4,1.2c-11.1,4.2-20.3,12.4-25.8,22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1050,289.7c7.6,1.1,15.2,1.1,22.8,0.1c7.3-1.5,14.5-3.9,21.3-7.1c0.6-0.2,1.1-0.6,1.5-1.1 c0.1-0.3,0.1-0.7,0-1s-0.3-0.6-0.6-0.9c-0.6-0.4-1.2-0.7-1.9-0.8c-7.6-1.9-15.6-1.4-23,1.4C1063.1,282.7,1056.3,285.9,1050,289.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1006.7,308.4c-2.4-5.2-3.8-10.9-3.8-16.6c-0.1-5.8,1.1-11.5,3.4-16.7c3.1,4.8,3.5,10.9,3,16.6 c-0.5,5.7-2.3,11.6-2.4,17.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M986.1,298c-6.5-0.1-12.9,1.2-18.9,3.7s-11.3,6.3-15.8,11c6.5,0.8,13.1-0.4,18.9-3.5c5.8-3,11.2-6.7,16.2-10.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M972.2,293.4c-6.3-0.5-12.4-1.3-18.5,0.6c-3.1,0.9-5.9,2.4-8.3,4.4c-2.4,2.1-4.4,4.6-5.7,7.5 c6,0.5,12-0.6,17.4-3.3C962.3,300,967.4,296.9,972.2,293.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M992.7,293.6c-5.6-3.7-11.5-7.5-18.1-9c-6.6-1.6-14.3-0.4-18.9,4.6c5.4,3.1,11.8,3.5,18.1,3.5 c6.2,0,13.8,0,19.7,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M992.8,293.9c-9.7-9.5-13.4-26.7-9.5-39.7C990.9,265.9,994.3,279.9,992.8,293.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1019.4,266.9c1.9-4.3,3.1-8.7,4.8-13.1c1.5-4.4,3.8-8.5,6.8-12c3-3.6,7.3-5.8,12-6.2 c-1.5,6.6-4.3,12.8-8.4,18.2c-4,5.4-9.1,9.9-15,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1014.6,272.5c-3-4.2-6.5-9.8-10.6-13c-2-1.6-4.3-2.8-6.8-3.5c-2.5-0.6-5.1-0.7-7.7-0.3 c2.6,4.6,6.2,8.5,10.6,11.4S1009.4,271.9,1014.6,272.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1015.7,267.2c-2.2-5-3.8-10.2-4.9-15.5c-1-5.4-0.1-10.9,2.4-15.8c5.3,10.1,7,20.9,2.6,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1019.5,235.9c3-10,12.2-17.4,22.1-20.7c1.2-0.5,2.5-0.7,3.9-0.6c0.6,0.1,1.3,0.3,1.8,0.8 c0.5,0.4,0.9,1,1.1,1.6c0.4,1.7-1,3.2-2.3,4.4C1038.2,227.9,1029.2,232.9,1019.5,235.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1019.6,227.7c0.1-6.5,1.1-12.9,2.9-19.1c2.1-6.1,6.1-11.8,12-14.5c1,6.5-1.9,13-5.3,18.6 c-3.5,5.6-7.6,10.9-9.7,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1019.4,232.2c-2.5-7.3-2.8-16.5-7.1-22.9c-3-4.4-7.9-7.5-10.6-12.1c-1.6,4.5-1.3,9.4,0.6,13.8 c2,4.3,4.7,8.2,8.1,11.5C1013.7,226,1016.4,228.5,1019.4,232.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1019.5,446.6c-0.2,0-0.4-48.6-0.4-108.5s0.1-108.5,0.3-108.5c0.2,0,0.4,48.6,0.4,108.5 S1019.7,446.6,1019.5,446.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1062,301.1c-0.6,0.3-1.2,0.5-1.9,0.7l-5,1.7c-4.2,1.4-10.1,3.5-16.4,6.1s-12.2,4.9-15.5,7.8 c-1.3,1.1-2.4,2.5-3.1,4.1c-0.5,1.1-0.6,1.9-0.6,1.9c-0.1,0,0-0.2,0-0.5c0.1-0.5,0.2-1,0.4-1.4c0.6-1.7,1.7-3.2,3-4.4 c2-1.7,4.3-3.1,6.7-4.2c2.7-1.2,5.6-2.6,8.8-3.9c6.3-2.6,12.2-4.6,16.5-6c2.2-0.7,3.9-1.2,5.1-1.5 C1060.7,301.3,1061.3,301.2,1062,301.1L1062,301.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1075.9,266.9c-0.2,0.2-0.3,0.4-0.5,0.5l-1.5,1.5l-5.7,5.2l-19.4,17.2c-7.5,6.7-14.1,13.1-18.7,18 c-2.3,2.4-4.1,4.4-5.3,5.8l-1.4,1.6c-0.3,0.3-0.5,0.5-0.5,0.5c0.1-0.2,0.2-0.4,0.4-0.6c0.3-0.4,0.7-1,1.3-1.7 c1.2-1.4,2.9-3.5,5.1-6c5.8-6.4,12-12.5,18.5-18.2c7.5-6.7,14.5-12.7,19.5-17.1l6-5.1l1.6-1.4 C1075.5,267.1,1075.7,267,1075.9,266.9L1075.9,266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1040.5,298.3c-0.2,0,1.4-3.8,3-8.3c1.6-4.6,2.3-8.5,2.5-8.5c-0.2,3-0.8,5.9-1.9,8.7c-0.7,2-1.4,3.9-2.3,5.8 C1041.4,296.8,1041,297.6,1040.5,298.3L1040.5,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1019.6,327.7c-0.4-0.4-0.8-0.9-1.2-1.4l-3-3.7c-2.5-3.2-6-7.7-9.9-12.6c-3.9-4.9-7.5-9.4-10-12.5l-3-3.7 c-0.4-0.4-0.7-0.9-1-1.4c0.4,0.4,0.9,0.8,1.2,1.3c0.8,0.8,1.9,2.1,3.2,3.6c2.7,3.1,6.3,7.5,10.2,12.4s7.3,9.3,9.7,12.7 c1.2,1.7,2.2,3,2.8,4C1019.1,326.8,1019.3,327.2,1019.6,327.7L1019.6,327.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1010.2,315.7c-1.9-2.1-3.2-4.6-3.9-7.3c-0.7-2.4-1-4.9-0.9-7.4h0.3c-0.1,0.6-0.2,0.9-0.3,0.9c0,0,0-0.3,0-0.9 h0.3c0.2,2.4,0.6,4.8,1.2,7.1C1007.9,310.8,1009,313.3,1010.2,315.7L1010.2,315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M998.2,300.6c-0.8-0.6-1.8-1.2-2.7-1.6c-2.4-0.7-5-0.9-7.5-0.6c-2.6,0.2-5.1,0.6-7.6,1.2 c-1,0.3-2.1,0.6-3.1,0.8c0.9-0.6,1.9-1,3-1.2c2.5-0.8,5.1-1.3,7.7-1.5c2.6-0.3,5.3,0,7.8,0.8C996.8,299,997.7,299.7,998.2,300.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M995.4,297c0,0.1-1.6-0.6-4.2-1.5c-3.4-1.1-6.9-1.8-10.4-2.1s-7.1-0.1-10.6,0.5c-2.7,0.5-4.3,1-4.4,0.9 c0.3-0.2,0.7-0.4,1.1-0.5c1-0.4,2.1-0.7,3.2-0.9c3.5-0.8,7.2-1,10.8-0.8c3.6,0.3,7.2,1.1,10.5,2.4c1,0.4,2,0.8,3,1.3 C995.1,296.7,995.4,296.9,995.4,297z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1019.4,281.5c-1.2-3.5-2.2-7-3-10.6c-1-3.5-1.8-7.1-2.4-10.7c1.2,3.5,2.2,7,3,10.6 C1018.1,274.3,1018.8,277.9,1019.4,281.5L1019.4,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1019.7,281.5c-1-2.2-2.1-4.3-3.4-6.3c-1.4-1.9-3.1-3.6-5-5.1c0.7,0.2,1.3,0.5,1.9,1c1.4,1,2.6,2.3,3.6,3.7 C1018.3,276.7,1019.3,279.1,1019.7,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1019.5,420.7c0,0-0.2-1.2-0.8-3.2c-0.8-2.9-1.9-5.7-3.2-8.4c-4.7-8.8-10.4-17-17.2-24.3 c-3.9-4.4-7.6-8.5-10.8-12.5c-2.8-3.5-5.4-7.2-7.7-11.1c-1.5-2.6-2.8-5.4-3.9-8.2c-0.3-1-0.6-1.9-0.8-2.4c-0.1-0.3-0.2-0.6-0.2-0.8 l1.2,3.1c1.2,2.8,2.5,5.5,4.1,8.1c2.3,3.8,4.9,7.5,7.8,10.9c3.2,3.9,6.9,8,10.8,12.5c6.8,7.4,12.6,15.6,17.2,24.6 c1.3,2.7,2.4,5.6,3.1,8.6c0.2,0.8,0.3,1.6,0.4,2.4C1019.6,420.1,1019.6,420.4,1019.5,420.7L1019.5,420.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1057.9,377.4c-0.6,0.4-1.3,0.8-2,1.1c-1.8,1-3.6,2.2-5.2,3.4c-2.5,1.9-4.8,4-6.9,6.3 c-2.4,2.5-4.9,5.5-7.5,8.6c-5,6.3-9.8,12-12.6,16.4c-1.4,2.2-2.5,4.1-3.2,5.4c-0.3,0.7-0.7,1.4-1.1,2c0-0.2,0.1-0.4,0.2-0.6 c0.1-0.4,0.4-0.9,0.7-1.6c0.9-1.9,1.9-3.8,3-5.6c3.8-5.8,8-11.3,12.5-16.6c2.5-3.2,5-6.1,7.5-8.7c2.2-2.2,4.5-4.3,7-6.2 c1.7-1.2,3.5-2.3,5.4-3.3c0.7-0.3,1.2-0.5,1.6-0.7C1057.4,377.4,1057.6,377.4,1057.9,377.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1058.7,391.4c-1.4,0.3-2.8,0.5-4.2,0.6c-3.4,0.4-6.8,1-10.1,2c-3.2,1.1-6.3,2.7-9,4.7 c-2.1,1.6-3.1,2.9-3.2,2.9c-0.1-0.1,0.2-0.4,0.6-1c0.7-0.8,1.4-1.6,2.2-2.3c2.7-2.2,5.8-3.9,9.1-5c3.3-1,6.8-1.6,10.2-1.9 C1055.9,391.4,1057.3,391.3,1058.7,391.4L1058.7,391.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1033.3,400.1c-0.2-0.1,1.7-3,3.2-7s1.7-7.5,2-7.5c0.1,0.8,0.1,1.5,0,2.3c-0.2,1.8-0.6,3.6-1.2,5.4 c-0.6,1.7-1.5,3.4-2.5,4.9C1034.5,398.9,1034,399.5,1033.3,400.1L1033.3,400.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1070.3,339.6c-0.2,0.2-0.4,0.3-0.7,0.4l-2,0.9c-0.9,0.4-1.9,0.8-3.1,1.5s-2.6,1.3-4.1,2.1l-2.3,1.3 c-0.8,0.5-1.6,1-2.5,1.5c-1.7,1-3.4,2.3-5.2,3.6c-7.8,5.8-14.6,12.9-20.2,20.9c-1.2,1.9-2.5,3.6-3.4,5.4c-0.5,0.9-1,1.7-1.5,2.5 l-1.2,2.4c-0.8,1.5-1.4,2.9-2,4.1c-0.6,1.2-1,2.3-1.4,3.2l-0.8,2c-0.1,0.2-0.2,0.5-0.3,0.7c0-0.2,0.1-0.5,0.2-0.7 c0.2-0.5,0.4-1.2,0.7-2.1c0.4-1.1,0.8-2.2,1.3-3.2c0.6-1.2,1.1-2.7,1.9-4.2c0.4-0.8,0.8-1.5,1.2-2.4c0.4-0.8,0.9-1.6,1.4-2.5 c1-1.8,2.2-3.5,3.4-5.4c5.6-8.1,12.4-15.2,20.4-21c1.9-1.3,3.6-2.6,5.3-3.6c0.8-0.5,1.7-1.1,2.5-1.5l2.3-1.3 c1.5-0.9,2.9-1.5,4.1-2.1s2.3-1,3.2-1.4l2.1-0.8C1069.8,339.7,1070,339.7,1070.3,339.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1040,360c0.3-1,0.9-1.8,1.7-2.5c1.9-1.6,4.2-2.5,6.7-2.6c2.4,0,4.8,0.5,7.1,1.4c1,0.3,1.8,0.7,2.7,1.3 c-1-0.2-1.9-0.5-2.8-0.8c-2.2-0.8-4.6-1.1-6.9-1.1s-4.6,0.8-6.4,2.2C1041.3,358.5,1040.6,359.2,1040,360L1040,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1035.4,364.7c2-3.9,2.5-8.4,1.4-12.7c0.4,0.6,0.7,1.2,0.8,1.9c0.4,1.6,0.5,3.2,0.3,4.8s-0.7,3.1-1.4,4.5 C1036,364.2,1035.5,364.7,1035.4,364.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M986,427.7c1,18.6,6.7,37.4,15.2,56.5h37.4c8.2-18.9,13.4-37.7,14.3-56.5H986z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1046.9,457.7c0,0.2-12.3,0.4-27.5,0.4s-27.5-0.2-27.5-0.4s12.3-0.3,27.5-0.3 C1034.6,457.3,1046.9,457.5,1046.9,457.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1046.1,464.4c0,0.2-11.6,0.4-25.8,0.4s-25.8-0.2-25.8-0.4s11.5-0.4,25.8-0.4S1046.1,464.2,1046.1,464.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1001.8,439.8c0.5,5.7,0.5,11.5,0,17.2C1001.4,451.3,1001.4,445.6,1001.8,439.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1021.9,439.8c0.5,5.9,0.5,11.9,0,17.8C1021.4,451.7,1021.4,445.8,1021.9,439.8L1021.9,439.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1040.7,439.7c0.5,6.1,0.5,12.1,0,18.2C1040.2,451.8,1040.2,445.7,1040.7,439.7L1040.7,439.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1051.8,439.8c0,0.2-14.5,0.4-32.3,0.4s-32.3-0.2-32.3-0.4s14.4-0.3,32.3-0.3S1051.8,439.6,1051.8,439.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M934.9,55.3H236.8c-9.5,0-17.2,7.7-17.2,17.2v519.6c0,9.5,7.7,17.2,17.2,17.2H935c9.5,0,17.2-7.7,17.2-17.2 V72.4C952.1,62.9,944.4,55.3,934.9,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M934.9,55.3H236.8c-9.5,0-17.2,7.7-17.2,17.2v519.6c0,9.5,7.7,17.2,17.2,17.2H935c9.5,0,17.2-7.7,17.2-17.2 V72.4C952.1,62.9,944.4,55.3,934.9,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M926.7,55.3H228.5c-9.5,0-17.2,7.7-17.2,17.2v519.6c0,9.5,7.7,17.2,17.2,17.2h698.2c9.5,0,17.2-7.7,17.2-17.2 V72.4C943.8,62.9,936.2,55.3,926.7,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M228.5,55.3h39.9v554h-39.9c-4.6,0-8.9-1.8-12.1-5s-5-7.6-5-12.1V72.4c0-4.6,1.8-8.9,5-12.1 C219.6,57.1,223.9,55.3,228.5,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M251.7,77.8H228c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4h23.6c1.9,0,3.4-1.5,3.4-3.4S253.5,77.8,251.7,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246,125.6h-12.4c-1.6,0-2.9,1.3-2.9,2.9v12.4c0,1.6,1.3,2.9,2.9,2.9H246c1.6,0,2.9-1.3,2.9-2.9v-12.4 C249,126.9,247.7,125.6,246,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M246,125.6h-12.4c-1.6,0-2.9,1.3-2.9,2.9v12.4c0,1.6,1.3,2.9,2.9,2.9H246c1.6,0,2.9-1.3,2.9-2.9v-12.4 C249,126.9,247.7,125.6,246,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246,184.9h-12.4c-1.6,0-2.9,1.3-2.9,2.9v12.4c0,1.6,1.3,2.9,2.9,2.9H246c1.6,0,2.9-1.3,2.9-2.9v-12.4 C249,186.2,247.7,184.9,246,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M246,184.9h-12.4c-1.6,0-2.9,1.3-2.9,2.9v12.4c0,1.6,1.3,2.9,2.9,2.9H246c1.6,0,2.9-1.3,2.9-2.9v-12.4 C249,186.2,247.7,184.9,246,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246,244.3h-12.4c-1.6,0-2.9,1.3-2.9,2.9v12.4c0,1.6,1.3,2.9,2.9,2.9H246c1.6,0,2.9-1.3,2.9-2.9v-12.4 C249,245.6,247.7,244.3,246,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M246,244.3h-12.4c-1.6,0-2.9,1.3-2.9,2.9v12.4c0,1.6,1.3,2.9,2.9,2.9H246c1.6,0,2.9-1.3,2.9-2.9v-12.4 C249,245.6,247.7,244.3,246,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246,303.6h-12.4c-1.6,0-2.9,1.3-2.9,2.9v12.4c0,1.6,1.3,2.9,2.9,2.9H246c1.6,0,2.9-1.3,2.9-2.9v-12.4 C249,304.9,247.7,303.6,246,303.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M246,303.6h-12.4c-1.6,0-2.9,1.3-2.9,2.9v12.4c0,1.6,1.3,2.9,2.9,2.9H246c1.6,0,2.9-1.3,2.9-2.9v-12.4 C249,304.9,247.7,303.6,246,303.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M239.6,572.2h-6c-1,0-2-0.4-2.8-1.2c-0.7-0.7-1.1-1.7-1.1-2.8v-12.4c0-1,0.4-2,1.1-2.8 c0.7-0.7,1.7-1.2,2.8-1.2h6c0.3,0,0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3h-6 c-0.5,0-1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4v12.4c0,0.5,0.2,1,0.6,1.4s0.8,0.6,1.4,0.6h6c0.3,0,0.5,0.1,0.7,0.3 s0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7C240.1,572.1,239.8,572.2,239.6,572.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M245.2,562.1L245.2,562.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2v-0.1l-0.1-0.1v-0.1l-2-3.1 c-0.1-0.2-0.4-0.4-0.6-0.4c-0.3-0.1-0.5,0-0.8,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.2,0.4c0,0.1,0,0.3,0,0.4 c0,0.1,0.1,0.3,0.1,0.4l1,1.5H235c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7s0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3h7.5l-1,2 c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.2,0.2,0.3s0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.4,0.1 c0.2,0,0.4-0.1,0.5-0.2s0.3-0.2,0.4-0.4l1.7-3.4v-0.1C245.3,562.3,245.3,562.2,245.2,562.1L245.2,562.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M910.8,125.4H765.5c-2.6,0-4.7,2.1-4.7,4.6v52.6c0,2.6,2.1,4.6,4.7,4.6h145.3c2.6,0,4.6-2.1,4.6-4.6V130 C915.4,127.5,913.4,125.4,910.8,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M910.8,125.4H765.5c-2.6,0-4.7,2.1-4.7,4.6v52.6c0,2.6,2.1,4.6,4.7,4.6h145.3c2.6,0,4.6-2.1,4.6-4.6V130 C915.4,127.5,913.4,125.4,910.8,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M871,176.3c10.7,0,19.3-8.6,19.3-19.3s-8.6-19.3-19.3-19.3s-19.3,8.6-19.3,19.3S860.3,176.3,871,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M871,157c-1.4,0-2.8-0.5-3.9-1.5s-1.7-2.3-1.8-3.7l-0.4-4.1c-0.1-0.8,0-1.6,0.3-2.4c0.2-0.8,0.7-1.5,1.2-2 c0.5-0.6,1.2-1.1,1.9-1.4c0.7-0.3,1.5-0.5,2.3-0.5h0.8c0.8,0,1.6,0.2,2.3,0.5c0.7,0.3,1.4,0.8,1.9,1.4s0.9,1.3,1.2,2 c0.2,0.8,0.3,1.6,0.3,2.4l-0.4,4.1c-0.1,1.4-0.8,2.7-1.8,3.7C873.8,156.5,872.4,157,871,157L871,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M871,157c-1.4,0-2.8-0.5-3.9-1.5s-1.7-2.3-1.8-3.7l-0.4-4.1c-0.1-0.8,0-1.6,0.3-2.4c0.2-0.8,0.7-1.5,1.2-2 c0.5-0.6,1.2-1.1,1.9-1.4c0.7-0.3,1.5-0.5,2.3-0.5h0.8c0.8,0,1.6,0.2,2.3,0.5c0.7,0.3,1.4,0.8,1.9,1.4s0.9,1.3,1.2,2 c0.2,0.8,0.3,1.6,0.3,2.4l-0.4,4.1c-0.1,1.4-0.8,2.7-1.8,3.7C873.8,156.5,872.4,157,871,157L871,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M887.8,167c-0.8,1.3-1.7,2.4-2.8,3.5c-2.1,2.1-4.7,3.7-7.5,4.7s-5.8,1.3-8.8,1s-5.8-1.3-8.3-2.9 s-4.7-3.7-6.2-6.3c0.5-2.2,1.7-4.2,3.5-5.6s3.9-2.2,6.2-2.2h14.4c2.2,0,4.4,0.8,6.2,2.2C886.1,162.9,887.3,164.8,887.8,167 L887.8,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M887.8,167c-0.8,1.3-1.7,2.4-2.8,3.5c-2.1,2.1-4.7,3.7-7.5,4.7s-5.8,1.3-8.8,1s-5.8-1.3-8.3-2.9 s-4.7-3.7-6.2-6.3c0.5-2.2,1.7-4.2,3.5-5.6s3.9-2.2,6.2-2.2h14.4c2.2,0,4.4,0.8,6.2,2.2C886.1,162.9,887.3,164.8,887.8,167 L887.8,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M812.4,156.8h-34.9c-0.7,0-1.3,0.6-1.3,1.3v2c0,0.7,0.6,1.3,1.3,1.3h34.9c0.7,0,1.3-0.6,1.3-1.3v-2 C813.7,157.4,813.1,156.8,812.4,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M820.9,144.1h-40.8c-2.1,0-3.8,1.7-3.8,3.9c0,2.1,1.7,3.9,3.8,3.9h40.8c2.1,0,3.9-1.7,3.9-3.9 C824.7,145.9,823,144.1,820.9,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M817.8,87.3h-76.5c-6.4,0-11.6,5.2-11.6,11.6l0,0c0,6.4,5.2,11.6,11.6,11.6h76.5c6.4,0,11.6-5.2,11.6-11.6l0,0 C829.4,92.5,824.2,87.3,817.8,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M817.5,102.4l-1.9-1.9c0.5-0.7,0.8-1.6,0.7-2.4c0-0.9-0.4-1.7-0.9-2.3c-0.6-0.7-1.3-1.1-2.2-1.3 c-0.8-0.2-1.7,0-2.5,0.4s-1.4,1-1.7,1.8c-0.4,0.8-0.5,1.7-0.2,2.5c0.2,0.8,0.7,1.6,1.4,2.1s1.5,0.8,2.4,0.8c0.8,0,1.6-0.3,2.2-0.7 l1.9,1.9c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.4 C817.7,102.6,817.6,102.5,817.5,102.4L817.5,102.4z M810.6,100c-0.4-0.4-0.6-0.8-0.7-1.3c-0.1-0.5,0-1,0.2-1.5s0.5-0.9,1-1.2 c0.4-0.3,0.9-0.4,1.4-0.4c0.4,0,0.8,0.1,1.2,0.3c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.4,0.4,0.8,0.4,1.2c0,0.4,0,0.9-0.2,1.3 s-0.4,0.7-0.8,1c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0.1-0.9,0.1-1.3-0.1C811.3,100.6,810.9,100.3,810.6,100L810.6,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M870,87.3h-17.9c-1.5,0-2.7,1.2-2.7,2.7v17.9c0,1.5,1.2,2.7,2.7,2.7H870c1.5,0,2.7-1.2,2.7-2.7V90 C872.6,88.5,871.4,87.3,870,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M913.2,87.3h-17.9c-1.5,0-2.7,1.2-2.7,2.7v17.9c0,1.5,1.2,2.7,2.7,2.7h17.9c1.5,0,2.7-1.2,2.7-2.7V90 C915.9,88.5,914.7,87.3,913.2,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M368,93.1h-68.7c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8H368c3.2,0,5.8-2.6,5.8-5.8 S371.2,93.1,368,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M478.5,216.9H298.2c-2.6,0-4.6,2.1-4.6,4.6v93c0,2.6,2.1,4.6,4.6,4.6h180.3c2.6,0,4.6-2.1,4.6-4.6v-93 C483.1,219,481,216.9,478.5,216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M478.5,216.9H298.2c-2.6,0-4.6,2.1-4.6,4.6v93c0,2.6,2.1,4.6,4.6,4.6h180.3c2.6,0,4.6-2.1,4.6-4.6v-93 C483.1,219,481,216.9,478.5,216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M454.8,247.6c6.2,0,11.1-5,11.1-11.1c0-6.2-5-11.2-11.1-11.2c-6.2,0-11.2,5-11.2,11.2 C443.6,242.6,448.6,247.6,454.8,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M440.4,247.6c6.2,0,11.1-5,11.1-11.1c0-6.2-5-11.2-11.1-11.2c-6.2,0-11.2,5-11.2,11.2 C429.2,242.6,434.2,247.6,440.4,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M440.4,247.6c6.2,0,11.1-5,11.1-11.1c0-6.2-5-11.2-11.1-11.2c-6.2,0-11.2,5-11.2,11.2 C429.2,242.6,434.2,247.6,440.4,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.9,255.6h-21.3c-3.6,0-6.5,2.9-6.5,6.5v12.1c0,3.6,2.9,6.5,6.5,6.5h21.3c3.6,0,6.5-2.9,6.5-6.5v-12.1 C345.4,258.5,342.5,255.6,338.9,255.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M359.9,233.7h-46.1c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7h46.1c1.5,0,2.7-1.2,2.7-2.7 C362.6,235,361.4,233.7,359.9,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M333.9,293.2h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C339.8,295.8,337.2,293.2,333.9,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M370.6,293.2h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 S373.9,293.2,370.6,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M407.3,293.2h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 S410.6,293.2,407.3,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M444,293.2h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9S447.3,293.2,444,293.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M359.9,233.7h-46.1c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7h46.1c1.5,0,2.7-1.2,2.7-2.7 C362.6,235,361.4,233.7,359.9,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M333.9,293.2h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C339.8,295.8,337.2,293.2,333.9,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M370.6,293.2h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 S373.9,293.2,370.6,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M407.3,293.2h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 S410.6,293.2,407.3,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M444,293.2h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 S447.3,293.2,444,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.5,343.4H298.2c-2.6,0-4.6,2.1-4.6,4.7v93c0,2.6,2.1,4.7,4.6,4.7h180.3c2.6,0,4.6-2.1,4.6-4.7v-93 C483.1,345.5,481,343.4,478.5,343.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M461.5,355.6h-23.3c-2.4,0-4.3,1.9-4.3,4.3v6.3c0,2.4,1.9,4.3,4.3,4.3h23.3c2.4,0,4.3-1.9,4.3-4.3v-6.3 C465.8,357.5,463.9,355.6,461.5,355.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.9,382.2h-21.3c-3.6,0-6.5,2.9-6.5,6.5v12.1c0,3.6,2.9,6.5,6.5,6.5h21.3c3.6,0,6.5-2.9,6.5-6.5v-12.1 C345.4,385.1,342.5,382.2,338.9,382.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M359.9,360.3h-46.1c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7h46.1c1.5,0,2.7-1.2,2.7-2.7 C362.6,361.5,361.4,360.3,359.9,360.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M333.9,419.7h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C339.8,422.4,337.2,419.7,333.9,419.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M370.6,419.7h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C376.5,422.4,373.9,419.7,370.6,419.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M407.3,419.7h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C413.2,422.4,410.6,419.7,407.3,419.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M444,419.7h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C449.9,422.4,447.3,419.7,444,419.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M478.5,468.8H298.2c-2.6,0-4.6,2.1-4.6,4.6v93c0,2.6,2.1,4.6,4.6,4.6h180.3c2.6,0,4.6-2.1,4.6-4.6v-93 C483.1,470.9,481,468.8,478.5,468.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M461.5,481h-23.3c-2.4,0-4.3,1.9-4.3,4.3v6.3c0,2.4,1.9,4.3,4.3,4.3h23.3c2.4,0,4.3-1.9,4.3-4.3v-6.3 C465.8,482.9,463.9,481,461.5,481z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.9,507.6h-21.3c-3.6,0-6.5,2.9-6.5,6.5v12.2c0,3.6,2.9,6.5,6.5,6.5h21.3c3.6,0,6.5-2.9,6.5-6.5v-12.2 C345.4,510.5,342.5,507.6,338.9,507.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M359.9,485.7h-46.1c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7h46.1c1.5,0,2.7-1.2,2.7-2.7 S361.4,485.7,359.9,485.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M333.9,545.1h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C339.8,547.8,337.2,545.1,333.9,545.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M370.6,545.1h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C376.5,547.8,373.9,545.1,370.6,545.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M407.3,545.1h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C413.2,547.8,410.6,545.1,407.3,545.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M444,545.1h-17c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9h17c3.3,0,5.9-2.6,5.9-5.9 C449.9,547.8,447.3,545.1,444,545.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M911.6,217.2H765.5c-2.6,0-4.7,2.1-4.7,4.6v137.7c0,2.6,2.1,4.6,4.7,4.6h146.1c2.6,0,4.7-2.1,4.7-4.6V221.8 C916.3,219.3,914.2,217.2,911.6,217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M911.6,217.2H765.5c-2.6,0-4.7,2.1-4.7,4.6v137.7c0,2.6,2.1,4.6,4.7,4.6h146.1c2.6,0,4.7-2.1,4.7-4.6V221.8 C916.3,219.3,914.2,217.2,911.6,217.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M909.1,289.5H768.9v0.5h140.2V289.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M909.3,310.4H769.1v0.5h140.2L909.3,310.4L909.3,310.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M909.5,331.4H768.9v0.5h140.6V331.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M905.3,230.7h-29.5c-1.1,0-2,0.9-2,2v3.2c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-3.2 C907.4,231.6,906.5,230.7,905.3,230.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M790.3,348.7h-12.9c-0.4,0-0.8,0.3-0.8,0.8v1.1c0,0.4,0.3,0.8,0.8,0.8h12.9c0.4,0,0.8-0.3,0.8-0.8v-1.1 C791.1,349,790.7,348.7,790.3,348.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M808.2,348.7h-11.8c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h11.8c0.7,0,1.3-0.6,1.3-1.3 S808.9,348.7,808.2,348.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M856.4,348.7h-12.9c-0.4,0-0.8,0.3-0.8,0.8v1.1c0,0.4,0.3,0.8,0.8,0.8h12.9c0.4,0,0.8-0.3,0.8-0.8v-1.1 C857.2,349,856.8,348.7,856.4,348.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M874.3,348.7h-11.8c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h11.8c0.7,0,1.3-0.6,1.3-1.3 C875.6,349.3,875,348.7,874.3,348.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M909.5,331.9H768.9l0.2-26.3c1.4-3.7,3.6-7.7,6.5-7.7c3.5,0,5.2,9.9,13.1,9.9c12.2,0,16-18.8,21.7-19.3 c8.6-0.8,12.4,15.4,20.6,15.5c7.4,0.1,10.2-7.2,13.9-11.5c1.4-1.6,3.3-2.8,5.4-3.2c2.7-0.7,3.3,0.2,7.1-1.1c11.7-4,9-19.3,19.5-18 c8.1,1,8.1,21.1,16.5,22.5c4.4,0.8,12-3.7,15.6-3.8L909.5,331.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M788.7,308.7c-5,0-7.5-3.7-9.6-6.7c-1.2-1.8-2.3-3.3-3.4-3.3c-2.1,0-4.1,2.5-6,7.4l-1-0.4 c2.1-5.5,4.4-8.1,7-8.1c1.7,0,2.9,1.8,4.3,3.8c1.9,2.8,4.3,6.2,8.7,6.2c7,0,11.3-6.8,14.7-12.2c2.4-3.8,4.4-7.1,7-7.3 c4.8-0.4,8,3.9,11.2,8.1c3,3.9,5.7,7.5,9.5,7.6c5.4,0.1,8.2-4,10.9-7.9c0.9-1.3,1.7-2.5,2.6-3.5c1.5-1.7,3.5-2.9,5.7-3.5 c0.9-0.2,1.8-0.3,2.8-0.3c1.5,0,2.9-0.2,4.3-0.8c5.4-1.9,7.7-6.4,9.7-10.4c2.2-4.4,4.3-8.6,10.1-7.8c4.4,0.6,6.5,6.1,8.6,11.5 c2,5.2,4,10.6,7.9,11.2c2.4,0.4,6.1-0.9,9.3-2.1c2-0.8,4-1.4,6.2-1.7v1.1c-2,0.3-4,0.9-5.8,1.7c-3.3,1.2-7.1,2.6-9.9,2.1 c-4.5-0.8-6.7-6.5-8.8-11.9c-2-5.3-4-10.3-7.7-10.8c-5.1-0.7-6.8,2.8-9,7.2c-2.1,4.2-4.4,8.9-10.3,10.9c-1.5,0.6-3.1,0.8-4.7,0.8 c-0.8,0-1.7,0.1-2.5,0.3c-2,0.5-3.8,1.6-5.1,3.1c-0.9,1.1-1.8,2.3-2.5,3.5c-2.7,4-5.9,8.5-11.8,8.4c-4.2-0.1-7.3-4.1-10.3-8 c-3.1-4.1-6.1-8-10.2-7.7c-2,0.2-3.9,3.2-6.2,6.8C800.8,301.7,796.3,308.7,788.7,308.7L788.7,308.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M839.1,303c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4S837.7,303,839.1,303z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M852.9,276h-28.3c-0.5,0-0.9,0.2-1.3,0.5c-0.3,0.3-0.5,0.8-0.5,1.3v13.7c0,0.5,0.2,0.9,0.5,1.3 c0.3,0.3,0.8,0.5,1.3,0.5h12.7l1,1.7c0,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.2-0.2 l1-1.7H853c0.5,0,0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.8,0.5-1.3v-13.7c0-0.2-0.1-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.4-0.6 c-0.2-0.2-0.4-0.3-0.6-0.4C853.3,276,853.1,276,852.9,276L852.9,276z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M848,279.3h-18.5c-0.3,0-0.6,0.3-0.6,0.6v3c0,0.3,0.2,0.6,0.6,0.6H848c0.3,0,0.6-0.3,0.6-0.6v-3 C848.5,279.6,848.3,279.3,848,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M843.1,286.8h-8.7c-0.3,0-0.6,0.3-0.6,0.6v1.2c0,0.3,0.2,0.6,0.6,0.6h8.7c0.3,0,0.6-0.3,0.6-0.6v-1.2 C843.7,287,843.4,286.8,843.1,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M848,279.3h-18.5c-0.3,0-0.6,0.3-0.6,0.6v3c0,0.3,0.2,0.6,0.6,0.6H848c0.3,0,0.6-0.3,0.6-0.6v-3 C848.5,279.6,848.3,279.3,848,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M843.1,286.8h-8.7c-0.3,0-0.6,0.3-0.6,0.6v1.2c0,0.3,0.2,0.6,0.6,0.6h8.7c0.3,0,0.6-0.3,0.6-0.6v-1.2 C843.7,287,843.4,286.8,843.1,286.8z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M909.2,268.5H768.9v0.5h140.3L909.2,268.5L909.2,268.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M912.6,387.2h-147c-2.6,0-4.7,2.1-4.7,4.7v173.8c0,2.6,2.1,4.7,4.7,4.7h147c2.6,0,4.7-2.1,4.7-4.7V391.8 C917.2,389.3,915.2,387.2,912.6,387.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M912.6,387.2h-147c-2.6,0-4.7,2.1-4.7,4.7v173.8c0,2.6,2.1,4.7,4.7,4.7h147c2.6,0,4.7-2.1,4.7-4.7V391.8 C917.2,389.3,915.2,387.2,912.6,387.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M836.1,399.2h-62.5c-1.1,0-2,0.9-2,2v7c0,1.1,0.9,2,2,2h62.5c1.1,0,2-0.9,2-2v-7 C838.1,400.1,837.2,399.2,836.1,399.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M800.3,430.4H773c-0.8,0-1.4,0.6-1.4,1.4v2c0,0.8,0.6,1.4,1.4,1.4h27.4c0.8,0,1.4-0.6,1.4-1.4v-2 C801.7,431,801.1,430.4,800.3,430.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M894.7,440h-121c-1.1,0-2,0.9-2,2s0.9,2,2,2h121c1.1,0,2-0.9,2-2S895.8,440,894.7,440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M894.7,440h-121c-1.1,0-2,0.9-2,2s0.9,2,2,2h121c1.1,0,2-0.9,2-2S895.8,440,894.7,440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M812.9,440h-39.3c-1.1,0-2,0.9-2,2s0.9,2,2,2h39.3c1.1,0,2-0.9,2-2C815,440.9,814,440,812.9,440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M800.3,472.3H773c-0.8,0-1.4,0.6-1.4,1.4v1.9c0,0.8,0.6,1.4,1.4,1.4h27.4c0.8,0,1.4-0.6,1.4-1.4v-1.9 C801.7,472.9,801.1,472.3,800.3,472.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M894.7,481.9h-121c-1.1,0-2,0.9-2,2s0.9,2,2,2h121c1.1,0,2-0.9,2-2C896.7,482.8,895.8,481.9,894.7,481.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M894.7,481.9h-121c-1.1,0-2,0.9-2,2s0.9,2,2,2h121c1.1,0,2-0.9,2-2C896.7,482.8,895.8,481.9,894.7,481.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M853.9,481.9h-80.3c-1.1,0-2,0.9-2,2s0.9,2,2,2h80.3c1.1,0,2-0.9,2-2C855.9,482.8,855,481.9,853.9,481.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M800.3,514.2H773c-0.8,0-1.4,0.6-1.4,1.4v2c0,0.8,0.6,1.4,1.4,1.4h27.4c0.8,0,1.4-0.6,1.4-1.4v-2 C801.7,514.8,801.1,514.2,800.3,514.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M894.7,523.8h-121c-1.1,0-2,0.9-2,2s0.9,2,2,2h121c1.1,0,2-0.9,2-2S895.8,523.8,894.7,523.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M894.7,523.8h-121c-1.1,0-2,0.9-2,2s0.9,2,2,2h121c1.1,0,2-0.9,2-2S895.8,523.8,894.7,523.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M830.8,523.8h-57.1c-1.1,0-2,0.9-2,2s0.9,2,2,2h57.1c1.1,0,2-0.9,2-2S831.9,523.8,830.8,523.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M732.5,125.5H301.6c-4.4,0-7.9,3.5-7.9,7.9v46c0,4.4,3.5,7.9,7.9,7.9h430.9c4.4,0,7.9-3.5,7.9-7.9v-46 C740.4,129,736.8,125.5,732.5,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M732.5,125.5H301.6c-4.4,0-7.9,3.5-7.9,7.9v46c0,4.4,3.5,7.9,7.9,7.9h430.9c4.4,0,7.9-3.5,7.9-7.9v-46 C740.4,129,736.8,125.5,732.5,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321.8,160.7c6.3,0,11.5-5.1,11.5-11.5c0-6.3-5.1-11.5-11.5-11.5c-6.3,0-11.5,5.1-11.5,11.5 C310.4,155.6,315.5,160.7,321.8,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M329.3,169.6h-15.1c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h15.1c1.4,0,2.5-1.1,2.5-2.5 C331.9,170.7,330.7,169.6,329.3,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M386.8,160.7c6.3,0,11.5-5.1,11.5-11.5c0-6.3-5.1-11.5-11.5-11.5c-6.3,0-11.5,5.1-11.5,11.5 S380.4,160.7,386.8,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M394.3,169.6h-15c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h15c1.4,0,2.5-1.1,2.5-2.5S395.7,169.6,394.3,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M451.7,160.7c6.3,0,11.5-5.1,11.5-11.5c0-6.3-5.1-11.5-11.5-11.5c-6.3,0-11.5,5.1-11.5,11.5 S445.4,160.7,451.7,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M459.2,169.6h-15c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h15c1.4,0,2.5-1.1,2.5-2.5S460.6,169.6,459.2,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516.6,160.7c6.3,0,11.5-5.1,11.5-11.5c0-6.3-5.1-11.5-11.5-11.5c-6.3,0-11.5,5.1-11.5,11.5 S510.3,160.7,516.6,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M524.2,169.6h-15c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h15c1.4,0,2.5-1.1,2.5-2.5S525.5,169.6,524.2,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M581.5,160.7c6.3,0,11.5-5.1,11.5-11.5c0-6.3-5.1-11.5-11.5-11.5c-6.3,0-11.5,5.1-11.5,11.5 C570.1,155.6,575.2,160.7,581.5,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M589.1,169.6h-15c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h15c1.4,0,2.5-1.1,2.5-2.5S590.5,169.6,589.1,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M646.5,160.7c6.3,0,11.5-5.1,11.5-11.5c0-6.3-5.1-11.5-11.5-11.5c-6.3,0-11.5,5.1-11.5,11.5 S640.2,160.7,646.5,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M654,169.6h-15c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h15c1.4,0,2.5-1.1,2.5-2.5S655.4,169.6,654,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M711.4,160.7c6.3,0,11.5-5.1,11.5-11.5c0-6.3-5.1-11.5-11.5-11.5c-6.3,0-11.5,5.1-11.5,11.5 C700,155.6,705.1,160.7,711.4,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M719,169.6h-15c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h15c1.4,0,2.5-1.1,2.5-2.5S720.3,169.6,719,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M735.4,216.8l-231,0.4c-2.6,0-4.6,2.1-4.6,4.7l0.6,344c0,2.6,2.1,4.6,4.7,4.6l231-0.4c2.6,0,4.6-2.1,4.6-4.7 L740,221.5C740,218.9,738,216.8,735.4,216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M735.4,216.8l-231,0.4c-2.6,0-4.6,2.1-4.6,4.7l0.6,344c0,2.6,2.1,4.6,4.7,4.6l231-0.4c2.6,0,4.6-2.1,4.6-4.7 L740,221.5C740,218.9,738,216.8,735.4,216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M748.8,255.1H491.5c-2,0-3.6,1.6-3.6,3.6v37.9c0,2,1.6,3.6,3.6,3.6h257.3c2,0,3.6-1.6,3.6-3.6v-37.9 C752.4,256.8,750.8,255.1,748.8,255.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M748.8,255.1H491.5c-2,0-3.6,1.6-3.6,3.6v37.9c0,2,1.6,3.6,3.6,3.6h257.3c2,0,3.6-1.6,3.6-3.6v-37.9 C752.4,256.8,750.8,255.1,748.8,255.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M711.5,270h-32.8c-1.7,0-3.1,1.4-3.1,3.1v0.6c0,1.7,1.4,3.1,3.1,3.1h32.8c1.7,0,3.1-1.4,3.1-3.1v-0.6 C714.5,271.4,713.2,270,711.5,270z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M702.9,312.1h-29.2c-1.7,0-3.1,1.4-3.1,3.1l0,0c0,1.7,1.4,3.1,3.1,3.1h29.2c1.7,0,3.1-1.4,3.1-3.1l0,0 C706,313.5,704.6,312.1,702.9,312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M702.9,354h-29.2c-1.7,0-3.1,1.4-3.1,3.1l0,0c0,1.7,1.4,3.1,3.1,3.1h29.2c1.7,0,3.1-1.4,3.1-3.1l0,0 C706,355.4,704.6,354,702.9,354z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M702.9,395.9h-29.2c-1.7,0-3.1,1.4-3.1,3.1l0,0c0,1.7,1.4,3.1,3.1,3.1h29.2c1.7,0,3.1-1.4,3.1-3.1l0,0 C706,397.3,704.6,395.9,702.9,395.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M702.9,436.8h-29.2c-1.7,0-3.1,1.4-3.1,3.1l0,0c0,1.7,1.4,3.1,3.1,3.1h29.2c1.7,0,3.1-1.4,3.1-3.1l0,0 C706,438.2,704.6,436.8,702.9,436.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M702.9,478.7h-29.2c-1.7,0-3.1,1.4-3.1,3.1l0,0c0,1.7,1.4,3.1,3.1,3.1h29.2c1.7,0,3.1-1.4,3.1-3.1l0,0 C706,480.1,704.6,478.7,702.9,478.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M702.9,520.6h-29.2c-1.7,0-3.1,1.4-3.1,3.1l0,0c0,1.7,1.4,3.1,3.1,3.1h29.2c1.7,0,3.1-1.4,3.1-3.1l0,0 C706,522,704.6,520.6,702.9,520.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M613.3,270h-61.6c-1.1,0-2,0.9-2,2v1.6c0,1.1,0.9,2,2,2h61.6c1.1,0,2-0.9,2-2V272 C615.3,270.9,614.4,270,613.3,270z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M613.3,270h-61.6c-1.1,0-2,0.9-2,2v1.6c0,1.1,0.9,2,2,2h61.6c1.1,0,2-0.9,2-2V272 C615.3,270.9,614.4,270,613.3,270z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M614.4,312.6h-55.6c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h55.6c1.1,0,2-0.9,2-2v-1.1 C616.4,313.5,615.5,312.6,614.4,312.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M614.4,312.6h-55.6c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h55.6c1.1,0,2-0.9,2-2v-1.1 C616.4,313.5,615.5,312.6,614.4,312.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M588.3,325.5h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-1.1 C590.3,326.4,589.4,325.5,588.3,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M588.3,325.5h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-1.1 C590.3,326.4,589.4,325.5,588.3,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M584.6,284.2h-32.9c-1.1,0-2,0.9-2,2v1.6c0,1.1,0.9,2,2,2h32.9c1.1,0,2-0.9,2-2v-1.6 C586.6,285.1,585.7,284.2,584.6,284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M624.7,354.5h-65.4c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h65.4c1.1,0,2-0.9,2-2v-1.1 C626.8,355.4,625.8,354.5,624.7,354.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M624.7,354.5h-65.4c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h65.4c1.1,0,2-0.9,2-2v-1.1 C626.8,355.4,625.8,354.5,624.7,354.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M588.9,367.3h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-1.1 C590.9,368.3,590,367.3,588.9,367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M588.9,367.3h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-1.1 C590.9,368.3,590,367.3,588.9,367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M590.9,396.2h-31.6c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h31.6c1.1,0,2-0.9,2-2v-1.1 C593,397.1,592.1,396.2,590.9,396.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M590.9,396.2h-31.6c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h31.6c1.1,0,2-0.9,2-2v-1.1 C593,397.1,592.1,396.2,590.9,396.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M609.4,437.8h-50c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h50c1.1,0,2-0.9,2-2v-1.1 C611.4,438.7,610.5,437.8,609.4,437.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M609.4,437.8h-50c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h50c1.1,0,2-0.9,2-2v-1.1 C611.4,438.7,610.5,437.8,609.4,437.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M590.9,479.5h-31.6c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h31.6c1.1,0,2-0.9,2-2v-1.1 C593,480.4,592.1,479.5,590.9,479.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M590.9,479.5h-31.6c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h31.6c1.1,0,2-0.9,2-2v-1.1 C593,480.4,592.1,479.5,590.9,479.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M609.4,521.1h-50c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h50c1.1,0,2-0.9,2-2v-1.1 C611.4,522,610.5,521.1,609.4,521.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M609.4,521.1h-50c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h50c1.1,0,2-0.9,2-2v-1.1 C611.4,522,610.5,521.1,609.4,521.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M584.6,284.2h-32.9c-1.1,0-2,0.9-2,2v1.6c0,1.1,0.9,2,2,2h32.9c1.1,0,2-0.9,2-2v-1.6 C586.6,285.1,585.7,284.2,584.6,284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M584.6,284.2h-32.9c-1.1,0-2,0.9-2,2v1.6c0,1.1,0.9,2,2,2h32.9c1.1,0,2-0.9,2-2v-1.6 C586.6,285.1,585.7,284.2,584.6,284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M588.9,409h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2V411 C590.9,409.9,590,409,588.9,409z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M588.9,409h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2V411 C590.9,409.9,590,409,588.9,409z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M588.9,450.7h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-1.1 C590.9,451.6,590,450.7,588.9,450.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M588.9,450.7h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-1.1 C590.9,451.6,590,450.7,588.9,450.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M588.9,492.3h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-1.1 C590.9,493.2,590,492.3,588.9,492.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M588.9,492.3h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2v-1.1 C590.9,493.2,590,492.3,588.9,492.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M588.9,534h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2V536 C590.9,534.9,590,534,588.9,534z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M588.9,534h-29.5c-1.1,0-2,0.9-2,2v1.1c0,1.1,0.9,2,2,2h29.5c1.1,0,2-0.9,2-2V536 C590.9,534.9,590,534,588.9,534z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M524.8,291.6c6.4,0,11.5-5.2,11.5-11.5c0-6.4-5.2-11.5-11.5-11.5c-6.4,0-11.5,5.2-11.5,11.5 C513.3,286.5,518.5,291.6,524.8,291.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M533.5,332.1c5.8,0,10.5-4.7,10.5-10.5s-4.7-10.5-10.5-10.5s-10.5,4.7-10.5,10.5 C523,327.4,527.7,332.1,533.5,332.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M533.5,373.8c5.8,0,10.5-4.7,10.5-10.5s-4.7-10.5-10.5-10.5s-10.5,4.7-10.5,10.5S527.7,373.8,533.5,373.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M533.5,415.6c5.8,0,10.5-4.7,10.5-10.5s-4.7-10.5-10.5-10.5s-10.5,4.7-10.5,10.5 C523,410.9,527.7,415.6,533.5,415.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M533.5,457.3c5.8,0,10.5-4.7,10.5-10.5s-4.7-10.5-10.5-10.5S523,441,523,446.8S527.7,457.3,533.5,457.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M533.5,499c5.8,0,10.5-4.7,10.5-10.5s-4.7-10.5-10.5-10.5s-10.5,4.7-10.5,10.5S527.7,499,533.5,499z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M533.5,540.8c5.8,0,10.5-4.7,10.5-10.5s-4.7-10.5-10.5-10.5s-10.5,4.7-10.5,10.5S527.7,540.8,533.5,540.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M608.3,235.1h-84.2c-1.1,0-2,0.9-2,2v5.1c0,1.1,0.9,2,2,2h84.2c1.1,0,2-0.9,2-2v-5.1 C610.3,236,609.4,235.1,608.3,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M36.6,326.2H158V171.4H36.6V326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M52.8,310.6h89.1V187H52.8L52.8,310.6L52.8,310.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M161.6,171.5H158v154.7h3.5V171.5H161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M82.5,265.8c10.7,0,19.3-8.6,19.3-19.3c0-10.7-8.6-19.3-19.3-19.3s-19.3,8.6-19.3,19.3 C63.2,257.1,71.9,265.8,82.5,265.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.8,297.2l-20.1-31.4l-20.1,31.1L130.8,297.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M87,242.2h41.7v-41.7H87V242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M374.5,192.7c-0.5,0.1-0.6,0.6-0.6,1s0.6,0.6,1,0.6l3.6-0.8c0.4-0.1,0.8-0.3,1.2-0.6c0.4-0.3,0.7-0.6,0.9-1 s0.4-0.8,0.4-1.2c0.1-0.4,0-0.9-0.1-1.3c-0.1-0.6-0.4-1.1-0.8-1.5c-0.4-0.4-0.9-0.7-1.4-0.9c-0.7-0.3-1.3-0.7-1.7-1.3 c-0.4-0.6-0.7-1.3-0.7-2c0-0.4-0.1-0.9-0.1-1.3C374.3,174.8,374.5,192.7,374.5,192.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M381.1,189.5c-0.2-0.9-0.8-1.6-1.6-2.1c0,0.1,0.1,0.2,0.1,0.3c0.1,0.4,0.1,0.9,0.1,1.3 c-0.1,0.4-0.2,0.9-0.4,1.2c-0.2,0.4-0.5,0.7-0.9,1s-0.8,0.5-1.2,0.6l-2.6,0.6v0.4c-0.5,0.1-0.6,0.6-0.6,1c0.1,0.4,0.6,0.6,1,0.6 l3.6-0.8c0.9-0.2,1.6-0.8,2.1-1.5C381.1,191.3,381.3,190.4,381.1,189.5L381.1,189.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M294.2,792.1h25.4l4.7-42.9l-29.7,0.1L294.2,792.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M296.8,775.8l0.8-0.7c5.8-5,15.7-4.9,21.2,0.2l0.4,0.4c0.7,0.6,1.2,1.3,1.6,2.1c0.4,0.8,0.6,1.7,0.6,2.6v2.8 c0,1.6,0.3,3.2,0.8,4.8l2.6,7.6c0.7,1.8,1,3.7,1,5.7v1c0,1.5-1.5,2.7-3.3,2.7h-30.4c-1.9,0-3.3-1.2-3.3-2.7v-0.4 c0-2.2,0.4-4.5,1.3-6.6l3-7.4c0.7-1.7,1.1-3.5,1.1-5.3l0.1-2.1c0.1-0.9,0.3-1.8,0.7-2.6C295.6,777.1,296.1,776.4,296.8,775.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M294.4,762.7v3.5h19.9c0.7,0,1.3,0.1,1.9,0.4c0.6,0.3,1.1,0.7,1.6,1.2c0.4,0.5,0.8,1.1,1,1.7s0.3,1.3,0.2,2 l-1.7,15.3h3.1l2.6-24L294.4,762.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M387.7,760.1l1.8,26.1l51.7,2.4L424,771.3c-3.3-2.4-5.3-7.5-6-11.5L387.7,760.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M406.9,766.5c2.4,0,4.7,0.7,6.8,1.9c2,1.2,3.7,3,4.8,5.1c0.9,1.7,2.1,3.2,3.6,4.4l12.4,12.4l7.7,0.3 L425.6,773c-3.7-2.9-6.2-7-7.3-11.6h-30.6l0.4,5.1L406.9,766.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M388.5,775.2c0,0,11.7,7.3,24.9,1c-0.3-1.4-0.2-2.8,0.3-4.1c0.5-1.3,1.3-2.5,2.3-3.3c2.2-1.7,6.6-2.3,7.8-0.7 c1.2,1.6,3.1,4.2,6.2,8c4.4,5.3,10.3,11.3,14.9,12.3c8.4,1.8,25.3-6.8,26.5,11.1c0,0-16.5,6.2-31.9,4.7c-10-1.2-19.9-3.5-29.4-7 v7.2h-24C386.1,804.3,380.7,784.1,388.5,775.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.4,792.9c0.2,3.9,0.8,7.7,1.8,11.5h24v-7.2c9.5,3.5,19.3,5.8,29.4,7c15.4,1.6,31.9-4.7,31.9-4.7 c-0.1-1.4-0.3-2.8-0.6-4.1c-12,6.1-25.9,7.4-38.9,3.5c-8.8-2.6-15.9-4.3-22.1-6.1C409.7,792.8,389.1,792.4,384.4,792.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.7,789.1c0,0-12.2,3.6-21.3-3.4c-6.8-5.2-10.2-8.2-7.5-14.4c0.5-1.2,1.3-2.2,2.4-3c1.1-0.8,2.3-1.2,3.7-1.2 C420,767.2,428.5,787.1,442.7,789.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M419.3,421.2v340.4h-31.5l-27.4-277.5c-0.1-0.9-0.5-1.7-1.1-2.3s-1.5-0.9-2.4-0.9l0,0c-0.9,0-1.7,0.3-2.3,0.9 c-0.6,0.6-1,1.4-1.1,2.3l-30.6,278.4h-28.8l9.5-339.4L419.3,421.2L419.3,421.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M420.4,761.5h-33.6l-0.7-6.9h34.2L420.4,761.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M420.4,761.6h-33.6l-0.7-6.9h34.2L420.4,761.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M420.4,761.6h-14.5v-7h14.4L420.4,761.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M308.7,762.2l27.9-266.9c0.5-4,2.4-7.7,5.5-10.4c3-2.7,6.9-4.2,11-4.1h3.9c-0.9,0-1.7,0.3-2.3,0.9 c-0.6,0.6-1,1.4-1.1,2.2l-30.7,278.6L308.7,762.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M419.4,423.6v331h-13.5l-3.8-331H419.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M374.6,161.8l3.8,44.5c0.2,2.6-0.5,5.3-2,7.5s-3.7,3.8-6.3,4.5l-2.4,0.7l2,17.4l-16.9-2.3l-19.4,1.5l2.1-46.1 l21.6-20.6L374.6,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M572.5,305.2c0,0,2.6,3.8-4.8,8.2s-27.9,4.9-27.9,4.9l12-22.2L572.5,305.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M532.6,296.1l5.7-6.3c2.5-2.8,5.5-5.1,8.8-6.7l9.7-4.9c0.4-0.2,0.8-0.3,1.2-0.3c0.4,0.1,0.8,0.3,1.1,0.7 c0.7,1,1,2.1,1,3.3c-0.1,1.2-0.5,2.3-1.3,3.2l-6.8,5c-0.2,0.1-0.3,0.3-0.3,0.5s0,0.4,0.1,0.6l0,0c0.1,0.2,0.3,0.3,0.4,0.3 c0.2,0.1,0.4,0.1,0.6,0l31.2-12c0.3-0.1,0.6-0.2,1-0.2c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.6,0.3,0.8,0.6c0.2,0.2,0.4,0.5,0.5,0.8 c0.2,0.6,0.2,1.2,0,1.7c-0.2,0.6-0.6,1-1.2,1.3l-13.8,6.8c0,0,5.7,1.7,1.4,7c0,0,3.3,5.4-4,9.8s-29.8,11-29.8,11L518,333.3 l-11.9-22.2L532.6,296.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M573.6,297.6l-10.2,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M572.4,305.1l-10.2,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M572.3,290.8l-10.2,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M567.7,313.4c-7.4,4.4-27.9,4.9-27.9,4.9L527,327l-1.5-4.2l12.6-8.6c0.8-0.5,1.7-0.8,2.7-0.8l8.3,0.3 c7.5,0.4,16.6-0.5,23-4.5C572.2,309.4,571.8,310.7,567.7,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.4,211.1c6.1,4.6,7.5,5,13.2,3.5c2-0.5,3.8-1.4,5.4-2.6c5.6-4.4,11.3-13.6,11.7-23.8l3.6-1.9c1-1.5,0.9-13.4-0.9-18.4 c4-3.1,8.5-4.6,11.1-4.4c0.8,1.2,0.7,2.4,1.7,5.1c5.7-11.4-7.6-17.3-10.4-18.9c-5.5-3-17.4-3.4-24.1-2.2 c-15.3,2.8-24.1,12.1-23.8,28.8C317.1,190.5,321.4,203.4,329.4,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.7,188.2c2.4,10.7,4.7,27.3,8,31.4c2.8,2,9.1-0.6,10.1-7.2c1-6.4,1.5-12.4-0.4-17c-0.2,3.5-6.2,7.5-8.5,3.7l-5.7-12.8 L359.7,188.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.4,192l2.3,2.1c1.6,0.5,3.3,0.9,5,1.1l-5.9,2.9L351.4,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M360,189.7c1,3.4,2.1,5.8-2.4,5.9c-8.5,0-10.2-11.2-5.5-13.8c0.5-0.3,1.1-0.6,1.7-0.6c0.6-0.1,1.2,0,1.8,0.1 c0.6,0.2,1.1,0.5,1.5,0.9s0.8,0.9,1,1.4L360,189.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M357.5,188.4c-0.1-1.1-0.5-2.1-1.1-3.1c-0.5-0.7-1.2-1.1-2-1.4c-0.4,0-0.8,0-1.3,0.1 c-0.4,0.1-0.8,0.3-1.1,0.6c-0.1,0.1-0.2,0.3-0.2,0.4s0,0.3,0.1,0.5c0.2,0.3,0.5,0.3,0.8,0.1c0.2-0.2,0.5-0.4,0.7-0.5 c0.3-0.1,0.6-0.1,0.9-0.1c0.5,0,0.8,0.4,1.3,1c0.5,0.7,0.8,1.6,0.9,2.5l0.2,1c0,0.3,0.3,0.4,0.6,0.4s0.4-0.3,0.4-0.6L357.5,188.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M380,187.9c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.3-0.3-0.3-0.5l-2.9-13c0-0.1,0-0.2,0-0.4 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.2s0.2-0.1,0.3-0.1s0.2,0,0.3,0s0.2,0.1,0.3,0.1s0.2,0.1,0.2,0.2 c0.1,0.1,0.1,0.2,0.1,0.3l2.9,13c0,0.2,0,0.5-0.1,0.7S380.2,187.8,380,187.9C380.2,187.9,380.1,187.9,380,187.9L380,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M378.2,178.9l-20.1,4.5l0.4,1.7l20.1-4.5L378.2,178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M325.3,762.5h-17l1-6.9H326L325.3,762.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M325.3,762.5h-33.5l0.5-6.9H326L325.3,762.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M325.1,762.5h-33.5l0.5-6.9h33.7L325.1,762.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M325.1,762.5h-16.4l0.7-6.9h16.4L325.1,762.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M373.7,241.4h-36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M367.7,219l-7.4-0.2c-0.5,0-1,0.1-1.5,0.3c-0.5,0.2-0.9,0.6-1.1,1c-0.3,0.4-0.5,0.9-0.6,1.4s0,1,0.2,1.5 l2.7,7.1h9L367.7,219z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M325.6,232.6l3.1-7c0.7-1.6,1.8-2.9,3.2-3.9s3.1-1.6,4.8-1.7c12.7-0.8,23.7,1.1,33.3,8.1 c0.7,0.5,1.2,1.2,1.5,1.9c0.3,0.8,0.5,1.6,0.4,2.4l-0.7,7.4L325.6,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M302.9,249.6l11.6-12.5c4.6-5,11.8-7.9,19.4-8l23.2-0.4c9.1-0.1,17.5,4,21.6,10.5l6.4,10.4H302.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M289.6,456.1l7.1,13.9l10.1-30.4L289.6,456.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M313.6,442.3l-26.1-58.7l-34.9-21.1l-3.1,13.2c-0.5,2.3-0.3,4.7,0.6,6.9l37.1,68.6L313.6,442.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M270.1,263.4l-19.2,106.9l36.7,13.3l17.9-142.8L279.2,252c-2.3,1-4.4,2.6-6,4.6 C271.6,258.5,270.5,260.9,270.1,263.4L270.1,263.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.5,383.6l17.9-142.8l-4.2,1.8l-19.8,141l24,54.6l6.2-1L287.5,383.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.3,449.6l3.3,6.5l23.6-22.7l-3.3-7.3L286.3,449.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M317.1,235.1c0,0-23,11.8-38.1,17.3c-2.3,0.9-4.3,2.5-5.7,4.6c-1.3,2.1-1.9,4.6-1.7,7.1 c2.2,23.9,17.3,64.2,17.3,64.2s10.2,44.6,10.2,51.7c0,7.2-2.5,91.8-2.5,91.8h116.6l17-6.5c0,0-10.3-78.1-12.4-100 c-2.1-21.9,1-47.9,1-47.9l-1.8-39.8l7.5-21.9L373.7,234L317.1,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M471.1,327.6l10.8,37l-8.2,5.5c-3.4,2.3-7.7,3.2-11.8,2.6c-4.1-0.7-7.8-2.9-10.3-6.2L410,312.4l-10.3-66.9 c0-0.1,0-0.1,0.1-0.1c0.6,0.3,9.2,2.8,16.4,5c6.5,1.9,12.1,6.2,15.6,12.1C443.6,282.1,470.8,327.1,471.1,327.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M419.4,380.8c-2.5-18-2.5-39.8-2.2-40.3l1.6-23c0.6-7-10.7-7.5-10.3-1.2c0,0-1.8,46.3,0.3,64.9 c2.1,18.6,12.8,87.2,12.8,87.2l8.6-3.3C430.2,465.2,422,399.3,419.4,380.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M516.5,303.3l-52.7,27.8l16.5,34.7l51-38.7L516.5,303.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M516.5,303.2l-6.6,3.5l15.5,24.5l6.3-4L516.5,303.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302.3,471.6c0.8-5.6,2.7-85.6,2.7-92.3c0-7-14.9-52.1-14.9-52.1s-14-39.8-16.1-63.2c-0.5-5,6.5-9.7,11.2-11.4 c14.9-5.4,31.4-16.9,31.4-16.9s-22.6,11.6-37.4,16.9c-2.3,0.8-4.3,2.4-5.6,4.5c-1.3,2.1-1.9,4.5-1.7,7 c2.1,23.4,16.9,64.4,16.9,64.4S299,373,299,380.1c0,7-2.5,91.8-2.5,91.8L302.3,471.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M342.2,471.4l4.4-36c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1s0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.1,0.2l8.2,36v0.1 c0,0,0,0.1-0.1,0.1l-0.1,0.1h-0.1h-12.6h-0.1c0,0-0.1,0-0.1-0.1C342.3,471.6,342.3,471.5,342.2,471.4 C342.1,471.5,342.1,471.5,342.2,471.4L342.2,471.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationArbeitsrecht);
export default __webpack_public_path__ + "static/media/Illustration_Arbeitsrecht.e35952f26083e0b511b49b579c0d2206.svg";
export { ForwardRef as ReactComponent };